import axios from "axios";
import Tito from "js/src/client/client.js";

export default async function (item) {
  tito.config = Object.assign(tito.config || {}, item[1]);

  // When https://js.tito.io/v2.js script is loaded using document.body.append(script), the following
  // seems to be needed to ensure dynamically loaded processors are loaded via the JS_HOST, without
  // this it attempts to load them from the host the widget is running on and 404's.
  __webpack_public_path__ = `https://${tito.config.js_host}/packs/`;

  // Set random session ID if one not already present
  if(!sessionStorage.getItem("sessionId")) {
    const random = (size) => {
      return Math.random().toString(36).substr(2, size);
    }

    const randomUUID = () => {
      return `${random(8)}-${random(4)}-${random(4)}-${random(4)}-${random(6)}${random(6)}`;
    }

    let sessionId = window.crypto ? window.crypto.randomUUID() : randomUUID();

    sessionStorage.setItem("sessionId", sessionId);
  }

  // Send session ID header with all AJAX requests
  axios.defaults.headers.common["Tito-Session-Id"] = sessionStorage.getItem("sessionId");
  Tito.http.defaults.headers.common["Tito-Session-Id"] = sessionStorage.getItem("sessionId");
}
